/**
 * @description 拨号事件
 * @author wangfupeng
 */

export default function (eventData = {}) {
    let phone = eventData.phone
    if (!phone) {
        console.error('phone number is null or undefined')
        return
    }

    // 拼接并拨号
    phone = `tel://${phone}`
    window.location.href = phone
}
